export default __webpack_public_path__ + "static/media/allery-4.10b390e9.svg";